export default "__VITE_ASSET__CT82r2JH__"